import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericIcon from '../GenericComponents/GenericIcon';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  
  const footerStyle: React.CSSProperties = {
    height: '190px',
    marginTop: '10px',
  };

  const hrStyle: React.CSSProperties = {
    borderTop: '1px solid #F1EFEC',
    background: 'transparent',
  };

  const linkStyle: React.CSSProperties = {
    textDecoration: 'none',
    color: '#fff',
  };

  const leftLinkStyle: React.CSSProperties = {
    float: 'left',
    marginLeft: '10px',
  };

  const middleLinkStyle: React.CSSProperties = {
    marginLeft: '20px',
  };

  const rightLinkStyle: React.CSSProperties = {
    float: 'right',
    marginRight: '20px',
  };

  const rightMostLinkStyle: React.CSSProperties = {
    float: 'right',
    marginRight: '50px',
  };

  return (
    <footer className={styles.footer}>
      <div style={footerStyle}>
        {/* Afbeeldingen */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          {/* Eerste afbeelding met link */}
          <a 
            href="https://www.provincedeliege.be/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ marginRight: "10px" }}
          >
            <img 
              src="https://commoncollections.be/images/footerProv.jpg" 
              alt="Province de Liège" 
              style={{ height: "100px" }} 
            />
          </a>
  
          {/* Tweede afbeelding met link */}
          <a 
            href="https://www.federation-wallonie-bruxelles.be/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img 
              src="https://commoncollections.be/images/footerFed.jpg" 
              alt="Fédération Wallonie-Bruxelles" 
              style={{ height: "100px" }} 
            />
          </a>
        </div>
  
        {/* Tekst onder de afbeeldingen */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <p>
            Une initiative de la Province de Liège
            <br />
            Contact :{" "}
            <a 
              href="mailto:commoncollections@provincedeliege.be" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "grey", textDecoration: "none" }}
            >
              commoncollections@provincedeliege.be
            </a>            
          </p>

          <p>
            <a 
              href="https://www.provincedeliege.be/fr/cookies" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "grey", textDecoration: "none", marginRight: "10px" }}
            >
              Charte d'utilisation
            </a>
            |  
            <a 
              href="https://www.provincedeliege.be/fr/confidentialite" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "grey", textDecoration: "none", marginLeft: "10px" }}
            >
              Politique de confidentialité
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
